import { EnvironmentProviders, Provider } from "@angular/core";
import { NGX_HOTJAR_ROUTER_INITIALIZER_PROVIDER } from "ngx-hotjar";

/**
 * Provides Hotjar router page-view tracking as a standalone provider
 * (replaces the former NgxHotjarRouterModule).
 *
 * NGX_HOTJAR_INITIALIZER_PROVIDER is intentionally omitted: HotjarService
 * handles script injection lazily via enable() once the user grants consent.
 *
 * Include the returned array in the `providers` of `bootstrapApplication()`.
 * Requires `NGX_HOTJAR_SETTINGS_TOKEN` to be provided separately.
 */
export function provideHotjarRouter(): (Provider | EnvironmentProviders)[] {
  return [NGX_HOTJAR_ROUTER_INITIALIZER_PROVIDER];
}
